import { useCallback } from 'react';

import { ButtonMantine, ButtonProps } from 'ui';

import { AddStudentModalStack } from '../../modals/AddStudentModalStack/AddStudentModalStack';
import { AddStudentModalStack as AddStudentModalStackEnum } from '../../modals/AddStudentModalStack/types';
import { useAddStudentModalStack } from '../../modals/AddStudentModalStack/useAddStudentModalStack';

interface AddStudentButtonProps extends Omit<ButtonProps, 'onClick'> {}

const AddStudentButton = ({ ...props }: AddStudentButtonProps) => {
  const { stack } = useAddStudentModalStack();

  const handleOpen = useCallback(() => {
    stack.open(AddStudentModalStackEnum.AddStudent);
  }, [stack]);

  return (
    <>
      <ButtonMantine onClick={handleOpen} {...props}>
        Add Student
      </ButtonMantine>
      <AddStudentModalStack stack={stack} />
    </>
  );
};

export { AddStudentButton };
